<template> 
   <Card
            v-for="company in props.companyList" :key="company.company_id"
            class="w-full md:w-1/3 lg:w-[23%] xl:w-[20%] text-center overflow-hidden"
          >
            <template #header> 
              <div  
                :style="coverPhoto(company.company_cover_photo)"
                class="h-24 xl:h-28 z-0 background-format"></div>  
            </template>
            <template #title>
              <div   
                :style="profilePhoto(company.company_logo)"
                class="w-28 h-28 z-10 -mt-16 xl:-mt-20 mx-auto rounded-full border-4 border-white background-format"
              ></div> 

              <h1 class="h-10 my-2.5 leading-5 font-medium text-lg text-oxford-blue overflow-hidden">{{company.company_name}}</h1> 
              <h2 class="h-10 leading-5 -mb-4 capitalize font-medium text-[0.91rem] overflow-hidden">{{company.company_type}}</h2> 
            </template>
            <template #footer>
              <div class="w-full pt-2 -mb-3 border-t border-color-iron">
                <RouterLink
                  :to="`/companies/${company.company_slug}`"
                  class="font-medium text-oxford-blue"
                  >{{ translate('Ver Perfil','ucfirst')}}</RouterLink
                >
              </div>
            </template>
          </Card> 
</template>

<script setup> 
import { RouterLink } from "vue-router";
import Card from "primevue/card"; 
import { translate } from "@/composables/translate";  


let props = defineProps({
  companyList: { 
    type: Array,
    required: true 
  }
})

function coverPhoto(urlPhoto) {  
  return urlPhoto 
  ? {backgroundImage: `url(${urlPhoto})`}
  : {backgroundImage: `url(img/default-cover-photo.png)`}
}

function profilePhoto (urlPhoto) { 
  return urlPhoto 
  ? {backgroundImage: `url(${urlPhoto})`}
  : {backgroundImage: `url(img/logo-icon-jobifull.png)`}
}

</script>

<style scoped> 
.background-format { 
  background-size: cover;
  background-position:center center;
  background-repeat: no-repeat;
}
</style>